import { Route, Routes, Navigate } from 'react-router-dom';

import { PERMISSION } from 'src/features/auth';
import { ParkingStatusLayout } from 'src/features/parkingStatus/components/ParkingStatusLayout';
import { Devices } from 'src/features/parkingStatus/routes/Devices';
import useHasPermissions from 'src/hooks/useHasPermissions';

const ParkingStatusRoutes = () => {
    const permissionsDevices = useHasPermissions([PERMISSION.PARKING_DEVICES]);
    return permissionsDevices ? (
        <Routes>
            <Route path="" element={<ParkingStatusLayout />}>
                <Route path="" element={<Devices />} />
                <Route path="*" element={<Navigate to=".." />} />
            </Route>
        </Routes>
    ) : (
        <Navigate to=".." />
    );
};

export default ParkingStatusRoutes;
